import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import MuiSwitch, { SwitchProps as MuiSwitchProps } from "@mui/material/Switch";
import CheckIcon from "@mui/icons-material/Check";
import React, { FunctionComponent } from "react";
import { white } from "designSystem/styles/color";

const PREFIX = "Switch";

const classes = {
	root: `${PREFIX}root`,
	check: `${PREFIX}check`,
};

const StyledBox = styled(Box)({
	[`&.${classes.root}`]: {
		display: "inline-block",
		position: "relative",
	},
	[`& .${classes.check}`]: {
		color: white[50],
		height: 16,
		left: 6,
		pointerEvents: "none",
		position: "absolute",
		top: 2,
		width: 16,
	},
});

export type SwitchProps = Omit<MuiSwitchProps, "checkedIcon" | "color" | "icon" | "size">;

const Switch: FunctionComponent<SwitchProps> = (props) => {
	return (
		<StyledBox 
			className={classes.root}
		>
			<MuiSwitch
				{...props}
				color="default"
				data-testid="Switch"
			/>
			{props.checked ? <CheckIcon className={classes.check} /> : null}
		</StyledBox>
	);
};

export default Switch;